import React from "react";
import {
  ROLE_LABELS,
  TeamPermission,
  useAccountAccess,
} from "../../hooks/useAccountAccess";
import styles from "./styles.module.scss";

/**
 * A page a teammate's role does not allow — placing an order as a viewer.
 * Links into it still exist (order details, App Insights), and the backend
 * would refuse at the very end, after the whole form was filled in; this says
 * so at the door instead.
 */
const RequirePermission: React.FC<{
  permission: TeamPermission;
  children: React.ReactNode;
}> = ({ permission, children }) => {
  const { can, role } = useAccountAccess();
  if (can(permission)) return <>{children}</>;

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>Not available for your role</h1>
      <p className={styles.text}>
        You are a {role ? ROLE_LABELS[role].toLowerCase() : "member"} in this
        account. Ask its owner or an admin to change your role in Settings →
        Team.
      </p>
    </div>
  );
};

export default RequirePermission;
